import { useState, useEffect, useContext } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useProperty } from '../hooks/useProperties.js';
import { sendContact } from '../api/client.js';
import Img from '../components/ui/Img.jsx';
import PropertyCard from '../components/property/PropertyCard.jsx';
import { FavsCtx, CmpCtx, ToastCtx } from '../App.jsx';
import { PROP_TYPES, BRAND } from '../data/constants.js';
import { MOCK_PROPERTIES } from '../api/mock.js';
import { adapt } from '../api/client.js';

function Lightbox({ imgs, start, onClose }) {
  const [i, setI] = useState(start);
  const [tx, setTx] = useState(null);
  useEffect(() => {
    const h = e => { if(e.key==='Escape')onClose(); if(e.key==='ArrowRight')setI(x=>(x+1)%imgs.length); if(e.key==='ArrowLeft')setI(x=>(x-1+imgs.length)%imgs.length); };
    window.addEventListener('keydown',h); document.body.style.overflow='hidden';
    return () => { window.removeEventListener('keydown',h); document.body.style.overflow=''; };
  }, []);
  return (
    <div className="lb" role="dialog" aria-label="Galería"
      onTouchStart={e=>setTx(e.touches[0].clientX)}
      onTouchEnd={e=>{ if(tx===null)return; const dx=e.changedTouches[0].clientX-tx; if(Math.abs(dx)>50)setI(x=>dx<0?(x+1)%imgs.length:(x-1+imgs.length)%imgs.length); setTx(null); }}>
      <button className="lb-x" onClick={onClose} aria-label="Cerrar">✕</button>
      <div className="lb-count tnum">{i+1} / {imgs.length}</div>
      <button className="lb-nav left" onClick={()=>setI(x=>(x-1+imgs.length)%imgs.length)} aria-label="Anterior">‹</button>
      <img className="lb-img" src={imgs[i]?.full} alt={"Foto "+(i+1)} />
      <button className="lb-nav right" onClick={()=>setI(x=>(x+1)%imgs.length)} aria-label="Siguiente">›</button>
      <div className="lb-strip">{imgs.map((im,k)=><button key={k} className={"lb-tn"+(k===i?" on":"")} onClick={()=>setI(k)}><img src={im.thumb} alt="" /></button>)}</div>
    </div>
  );
}

function ContactForm({ p }) {
  const [d,setD]=useState({nombre:'',contacto:'',mensaje:`Hola, me interesa la propiedad ${p?.ref||''}. ¿Podemos coordinar una visita?`,canal:'whatsapp',consent:false});
  const [er,setEr]=useState({});
  const [sent,setSent]=useState(false);
  const [loading,setLoading]=useState(false);
  const upd=(k,v)=>setD(s=>({...s,[k]:v}));
  const submit=async(e)=>{
    e.preventDefault();
    const errs={};
    if(!d.nombre.trim()) errs.nombre='Decinos tu nombre';
    if(!d.contacto.trim()) errs.contacto='Dejá un teléfono o email';
    if(!d.consent) errs.consent='Necesitamos tu consentimiento';
    setEr(errs); if(Object.keys(errs).length) return;
    setLoading(true);
    try { await sendContact({name:d.nombre,phone:d.contacto,email:d.contacto,message:d.mensaje,propertyId:p?.id}); setSent(true); }
    catch(err){ setEr({submit:err.message}); }
    finally{ setLoading(false); }
  };
  if(sent) return <div className="cf-sent"><div className="cf-sent-ic">✓</div><h4>¡Consulta enviada!</h4><p>Te contactamos a la brevedad. También podés escribirnos directo por WhatsApp.</p><a className="btn btn-wa btn-block" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Ir a WhatsApp</a></div>;
  return (
    <form className="cf" onSubmit={submit} noValidate>
      <div className="field"><label htmlFor="cf-n">Nombre</label><input id="cf-n" className={"input"+(er.nombre?" err":"")} value={d.nombre} onChange={e=>upd('nombre',e.target.value)} placeholder="Tu nombre" />{er.nombre&&<span className="field-err">{er.nombre}</span>}</div>
      <div className="field"><label htmlFor="cf-c">Teléfono o email</label><input id="cf-c" className={"input"+(er.contacto?" err":"")} value={d.contacto} onChange={e=>upd('contacto',e.target.value)} placeholder="+54 11 …" />{er.contacto&&<span className="field-err">{er.contacto}</span>}</div>
      <div className="field"><label htmlFor="cf-m">Mensaje</label><textarea id="cf-m" className="input" rows={3} value={d.mensaje} onChange={e=>upd('mensaje',e.target.value)} /></div>
      <div className="cf-canales">{[['whatsapp','WhatsApp'],['llamada','Llamada'],['email','Email']].map(([v,l])=><button key={v} type="button" className={"cf-canal"+(d.canal===v?" on":"")} onClick={()=>upd('canal',v)}>{l}</button>)}</div>
      <label className={"cf-consent"+(er.consent?" err":"")}><input type="checkbox" checked={d.consent} onChange={e=>upd('consent',e.target.checked)} /><span className="fc-box">{d.consent&&'✓'}</span><span>Acepto ser contactado por Abriola.</span></label>
      {er.submit&&<p className="field-err">{er.submit}</p>}
      <button className="btn btn-primary btn-block cf-submit" type="submit" disabled={loading}>{loading?'Enviando…':'Enviar consulta →'}</button>
      <p className="cf-alt">o <a href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">escribinos por WhatsApp</a></p>
    </form>
  );
}

export default function Detail() {
  const { slug } = useParams();
  const { data: p, loading, error } = useProperty(slug);
  const { favs, toggleFav } = useContext(FavsCtx);
  const { cmp, toggleCmp }  = useContext(CmpCtx);
  const { showToast }        = useContext(ToastCtx);
  const [lb, setLb]          = useState(null);
  const nav                  = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  useEffect(() => { document.body.classList.toggle('has-stickybar', true); return () => document.body.classList.remove('has-stickybar'); }, []);

  if (loading) return <div className="container" style={{padding:'80px 0',textAlign:'center'}}><div className="skel" style={{width:200,height:28,margin:'0 auto 16px',borderRadius:8}}/></div>;
  if (error || !p) return <div className="container notfound"><h1>Propiedad no encontrada</h1><p>Puede que ya no esté disponible.</p><button className="btn btn-primary" onClick={()=>nav('/buscar?op=venta')}>Ver disponibles</button></div>;

  const isFav = favs.includes(p.id);
  const inCmp = cmp.includes(p.id);
  const similar = MOCK_PROPERTIES.map(adapt).filter(x=>x.id!==p.id&&(x.type===p.type||x.neighborhood===p.neighborhood)).slice(0,3);

  const specs = [];
  if(p.type!=='terreno'){
    if(p.rooms>0) specs.push([p.rooms,'Ambientes']); if(p.bedrooms>0) specs.push([p.bedrooms,'Dormitorios']);
    specs.push([p.bathrooms,'Baños']); specs.push([(p.coveredArea||p.totalArea),'m² cub.']);
    if(p.totalArea>p.coveredArea) specs.push([p.totalArea,'m² tot.']); if(p.parkingSpaces>0) specs.push([p.parkingSpaces,'Cocheras']);
  } else { specs.push([p.totalArea,'m² de lote']); }

  const fmtPrice = p.currency==='USD'?'US$ ':'$ '; 

  return (
    <div className="detalle">
      {lb!==null && <Lightbox imgs={p.images} start={lb} onClose={()=>setLb(null)} />}
      <div className="container det-crumbs-wrap">
        <nav className="crumbs" aria-label="Ruta">
          <Link to="/">Inicio</Link> › <Link to={"/buscar?op="+p.operationType}>{p.operationType==='alquiler'?'Alquilar':'Comprar'}</Link> › <Link to={"/buscar?op="+p.operationType+"&tipo="+p.type}>{PROP_TYPES[p.type]}</Link> › <span>{p.neighborhood}</span>
        </nav>
      </div>
      <div className="container">
        <div className="gal">
          <button className="gal-main" onClick={()=>setLb(0)} aria-label="Abrir galería">
            <Img src={p.images[0]?.full} alt={p.title} priority ratio={null} />
            <span className="gal-count">📷 {p.images.length} fotos</span>
          </button>
          <div className="gal-side">
            {p.images.slice(1,5).map((im,i)=>(
              <button key={i} className="gal-thumb" onClick={()=>setLb(i+1)} aria-label={"Foto "+(i+2)}>
                <Img src={im.full} alt={p.title} ratio={null} />
                {i===3&&p.images.length>5&&<span className="gal-more">+{p.images.length-5}</span>}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="container det-layout">
        <div className="det-main">
          <div className="det-head">
            <div className="det-head-top">
              <span className="det-op">{p.operationType==='alquiler'?'En alquiler':'En venta'}</span>
              <div className="det-head-actions">
                <button className={"det-mini"+(inCmp?" on":"")} onClick={()=>toggleCmp(p.id)}>⇄ <span>Comparar</span></button>
                <button className="det-mini" onClick={()=>{navigator.clipboard?.writeText(location.href);showToast('Enlace copiado');}}>📤 <span>Compartir</span></button>
                <button className={"det-mini"+(isFav?" on":"")} onClick={()=>toggleFav(p.id)}>♥ <span>{isFav?'Guardada':'Guardar'}</span></button>
              </div>
            </div>
            <h1 className="det-title">{p.title}</h1>
            <div className="det-loc">📍 {p.address}</div>
          </div>
          <div className="det-specs">{specs.map(([v,l],i)=><div key={i} className="det-spec"><b className="tnum">{v}</b><span>{l}</span></div>)}</div>
          <section className="det-block"><h2 className="det-h2">Descripción</h2><p className="det-desc">{p.description}</p></section>
          {p.amenities.length>0&&<section className="det-block"><h2 className="det-h2">Características y amenities</h2><div className="amen-grid">{p.amenities.map(a=><div key={a} className="amen"><span>✓</span><span>{a}</span></div>)}</div></section>}
          <section className="det-block"><h2 className="det-h2">Ficha técnica</h2>
            <div className="facts">
              {[['Tipo',PROP_TYPES[p.type]],['Operación',p.operationType==='alquiler'?'Alquiler':'Venta'],['Estado',p.status||'—'],['m² cubiertos',p.coveredArea||'—'],['m² totales',p.totalArea||'—'],p.age!=null?['Antigüedad',p.age===0?'A estrenar':p.age+' años']:null,p.floor?['Piso',p.floor]:null,p.expenses?['Expensas','$ '+p.expenses.toLocaleString('es-AR')]:null,['Código',p.ref]].filter(Boolean).map(([k,v],i)=>(
                <div key={i} className="fact"><span className="fact-k">{k}</span><span className="fact-v">{v}</span></div>
              ))}
            </div>
          </section>
          {similar.length>0&&<section className="det-block"><h2 className="det-h2">Propiedades similares</h2><div className="sim-grid">{similar.map(s=><PropertyCard key={s.id} p={s} />)}</div></section>}
        </div>
        <aside className="det-aside">
          <div className="price-card">
            <div className="pc-price">{fmtPrice}{p.price.toLocaleString('es-AR')}{p.operationType==='alquiler'?<span style={{fontSize:16}}>/mes</span>:''}</div>
            {p.expenses>0&&<div className="pc-exp">+ $ {p.expenses.toLocaleString('es-AR')} expensas</div>}
            {p.creditEligible&&<div className="pc-credit">✓ Apto crédito hipotecario</div>}
            <div className="pc-agent"><div className="pc-avatar"><Img src={p.agent?.photo} alt={p.agent?.name} ratio="1" /></div><div><div className="pc-aname">{p.agent?.name}</div><div className="pc-arole">{p.agent?.role}</div></div></div>
            <div className="pc-cta">
              <a className="btn btn-wa btn-block" href={`https://wa.me/${p.agent?.whatsapp||BRAND.waVentas}`} target="_blank" rel="noopener">💬 Consultar por WhatsApp</a>
              <a className="btn btn-ghost btn-block" href={"tel:"+BRAND.phoneVentas.replace(/[^0-9+]/g,'')}>📞 {BRAND.phoneVentas}</a>
            </div>
          </div>
          <div className="consulta-card" id="consulta"><h3 className="cc-title">Consultá por esta propiedad</h3><ContactForm p={p} /></div>
        </aside>
      </div>
      <div className="det-stickybar">
        <div className="dsb-price"><span>{p.operationType==='alquiler'?'Alquiler':'Venta'}</span><b>{fmtPrice}{p.price.toLocaleString('es-AR')}{p.operationType==='alquiler'?'/mes':''}</b></div>
        <div className="dsb-actions">
          <button className={"dsb-fav"+(isFav?" on":"")} onClick={()=>toggleFav(p.id)} aria-label="Guardar">♥</button>
          <a className="btn btn-wa dsb-wa" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Consultar</a>
        </div>
      </div>
    </div>
  );
}
